import { useEffect, useRef } from 'react';

import { analyticsMFAMethodOptionsShown } from '../../api/services/Analytics';

export type MFAChoiceViewState = 'none' | 'choice' | 'code';

export const useMFAChoiceAnalytics = (state: MFAChoiceViewState) => {
  const previousState = useRef<MFAChoiceViewState>('none');

  useEffect(() => {
    if (state === 'choice' && previousState.current !== 'choice') {
      analyticsMFAMethodOptionsShown(previousState.current === 'code' ? 'return' : 'initial');
    }
    previousState.current = state;
  }, [state]);
};
